module.exports = __webpack_public_path__ + "img/11.c42512a1.jpg";